export default "__VITE_ASSET__170af26b__"